import { useSelector } from "react-redux";
import { Footer, Header } from "@app/components/organisms";
import {
  DataAlert,
  ErrorPopup,
  Loading,
  Breadcrumb,
} from "@app/components/atoms";
import { RootState } from "@app/store";
import { useEffect } from "react";
import { useForceLogout } from "@app/hooks/useForceLogout";
import { useAuth } from "@app/hooks";

type Props = {
  children: React.ReactNode;
};

export function DefaultLayout({ children }: Props) {
  const error = useSelector((state: RootState) => state?.error?.data);
  const msg = useSelector((state: RootState) => state?.msg?.value);
  const { getTimer, setTimer, isExpired } = useForceLogout();
  const { logout } = useAuth();
  const isLoading = useSelector(
    (state: RootState) => state?.loading?.isLoading,
  );
  const isMachinePage = useSelector(
    (state: RootState) => state?.inspection?.isMachinePage,
  );

  useEffect(() => {
    const handleExpire = (e: StorageEvent | MouseEvent) => {
      const timer = getTimer();
      const expireResult = isExpired();

      if (expireResult || (e.type === "storage" && !timer)) {
        logout();
        return;
      }

      setTimer();
    };

    document.addEventListener("click", handleExpire);
    window.addEventListener("storage", handleExpire);

    return () => {
      document.removeEventListener("click", handleExpire);
      window.removeEventListener("storage", handleExpire);
    };
  }, [getTimer, isExpired, logout, setTimer]);

  return (
    <>
      <Header />
      <div className="page-content">
        <Breadcrumb />
        <main className="page-main min-height-no-footer">{children}</main>
      </div>
      {!isMachinePage && <Footer />}
      {!!msg && <DataAlert content={msg} />}
      {!!error.title && <ErrorPopup error={error} />}
      {!!isLoading && <Loading />}
    </>
  );
}
